import styles from "./Table.module.css"; // Import CSS Module

import {
  Table as ReactTableInstance,
  Row,
  flexRender,
  HeaderGroup,
  Cell,
} from "@tanstack/react-table";

interface TableProps<T> {
  table: ReactTableInstance<T>; // Type for the react-table instance
}

const Table = <T,>({ table }: TableProps<T>) => {
  return (
    <table className={styles.table}>
      <TableHeader headerGroups={table.getHeaderGroups()} />
      <TableBody rows={table.getRowModel().rows} />
    </table>
  );
};

interface TableHeaderProps<T> {
  headerGroups: HeaderGroup<T>[];
}

const TableHeader = <T,>({ headerGroups }: TableHeaderProps<T>) => {
  return (
    <thead>
      {headerGroups.map((headerGroup) => (
        <tr key={headerGroup.id}>
          {headerGroup.headers.map((header) => (
            <th key={header.id} className={styles.th}>
              <div>
                {flexRender(
                  header.column.columnDef.header,
                  header.getContext()
                )}
              </div>
            </th>
          ))}
        </tr>
      ))}
    </thead>
  );
};

interface TableBodyProps<T> {
  rows: Array<Row<T>>;
}

const TableBody = <T,>({ rows }: TableBodyProps<T>) => {
  return (
    <tbody>
      {rows.map((row) => (
        <tr key={row.id}>
          {row.getVisibleCells().map((cell) => (
            <TableCell key={cell.id} cell={cell} />
          ))}
        </tr>
      ))}
    </tbody>
  );
};

interface TableCellProps<T> {
  cell: Cell<T, any>;
}

const TableCell = <T,>({ cell }: TableCellProps<T>) => {
  return (
    <td className={styles.td}>
      {flexRender(cell.column.columnDef.cell, cell.getContext())}
    </td>
  );
};

export default Table;
